import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Espera que api tenha: list(params), getById(id), create(payload), update(id,payload)
export function makeCrudSlice({ name, api }) {
  const list = createAsyncThunk(`${name}/list`, async (params, thunkApi) => {
    try {
      return await api.list(params);
    } catch (e) {
      return thunkApi.rejectWithValue({
        message: e.message,
        status: e.status,
        data: e.data,
      });
    }
  });

  const getById = createAsyncThunk(`${name}/getById`, async (id, thunkApi) => {
    try {
      return await api.getById(id);
    } catch (e) {
      return thunkApi.rejectWithValue({
        message: e.message,
        status: e.status,
        data: e.data,
      });
    }
  });

  const createOne = createAsyncThunk(
    `${name}/create`,
    async (payload, thunkApi) => {
      try {
        return await api.create(payload);
      } catch (e) {
        return thunkApi.rejectWithValue({
          message: e.message,
          status: e.status,
          data: e.data,
        });
      }
    },
  );

  const updateOne = createAsyncThunk(
    `${name}/update`,
    async ({ id, payload }, thunkApi) => {
      try {
        return await api.update(id, payload);
      } catch (e) {
        return thunkApi.rejectWithValue({
          message: e.message,
          status: e.status,
          data: e.data,
        });
      }
    },
  );

  const initialState = {
    items: [],
    count: 0,
    byId: {},
    current: null,
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      clearError(state) {
        state.error = null;
      },
      clearCurrent(state) {
        state.current = null;
      },
    },
    extraReducers: (builder) => {
      builder
        // list
        .addCase(list.pending, (state) => {
          state.status = "loading";
          state.error = null;
        })
        .addCase(list.fulfilled, (state, action) => {
          state.status = "succeeded";
          const payload = action.payload;

          // backend costuma retornar {count, rows} (pelos services)【turn3file6†auctionService.js†L23-L31】
          const rows = payload?.rows ?? payload ?? [];
          const count = payload?.count ?? rows.length;

          state.items = rows;
          state.count = count;

          state.byId = rows.reduce((acc, item) => {
            if (item?.id) acc[item.id] = item;
            return acc;
          }, {});
        })
        .addCase(list.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.payload?.message || action.error.message;
        })

        // getById
        .addCase(getById.pending, (state) => {
          state.status = "loading";
          state.error = null;
        })
        .addCase(getById.fulfilled, (state, action) => {
          state.status = "succeeded";
          state.current = action.payload;
          if (action.payload?.id)
            state.byId[action.payload.id] = action.payload;
        })
        .addCase(getById.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.payload?.message || action.error.message;
        })

        // create
        .addCase(createOne.fulfilled, (state, action) => {
          const item = action.payload;
          if (item?.id) state.byId[item.id] = item;
          state.items = [item, ...state.items];
          state.count += 1;
        })
        .addCase(createOne.rejected, (state, action) => {
          state.error = action.payload?.message || action.error.message;
        })

        // update
        .addCase(updateOne.fulfilled, (state, action) => {
          const item = action.payload;
          if (!item?.id) return;
          state.byId[item.id] = item;
          state.items = state.items.map((x) => (x.id === item.id ? item : x));
          if (state.current?.id === item.id) state.current = item;
        })
        .addCase(updateOne.rejected, (state, action) => {
          state.error = action.payload?.message || action.error.message;
        });
    },
  });

  return {
    reducer: slice.reducer,
    actions: slice.actions,
    thunks: { list, getById, createOne, updateOne },
  };
}
